import { NonNegative } from './non-negative';
const get = (subscriptions, channel)=>{
    var _subscriptions_channel;
    return (_subscriptions_channel = subscriptions[channel]) !== null && _subscriptions_channel !== void 0 ? _subscriptions_channel : NonNegative.zero();
};
const set = (subscriptions, channel, value)=>{
    subscriptions[channel] = value;
    return subscriptions;
};
export const Subscriptions = {
    empty: ()=>({}),
    add: (subscriptions, channel)=>set(subscriptions, channel, NonNegative.increment(get(subscriptions, channel))),
    remove: (subscriptions, channel)=>set(subscriptions, channel, NonNegative.decrement(get(subscriptions, channel))),
    has_none: (subscriptions, channel)=>NonNegative.is_zero(get(subscriptions, channel)),
    activeCount: (subscriptions)=>Object.values(subscriptions).filter((value)=>value != null && !NonNegative.is_zero(value)).length
};
